<template>
  <div>

    <Head :title="`${customer.first_name} ${customer.last_name} - Customer Profile`" />
    <h1 class="mb-8 text-3xl font-bold">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 mb-1"
        style="display: inline !important;">
        <path fill-rule="evenodd"
          d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
          clip-rule="evenodd" />
      </svg>
      <Link class="text-orange-600 hover:text-orange-500" href="/online-customers">Customers</Link> &raquo; {{
      customer.first_name }} {{ customer.last_name }}
      <a href="#" class="text-orange-600 hover:text-orange-500" @click="openEditCustomerPrompt()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6" style="display: inline !important;">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
        </svg>
      </a>
    </h1>
    <div class="flex items-center justify-end mb-6">
      <Link class="btn-orange float-right mr-3"
        :href="url(customer)">
      <span>Create</span>
      <span class="hidden md:inline">&nbsp;Order</span>
      </Link>
      <a class="btn-orange float-right" href="#" @click="openCreateCustomerVoucherPrompt">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Voucher</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mb-5">
      <table class="w-full whitespace-nowrap">
        <tr>
          <td class="pb-3 pt-3 px-3"><strong>Freshworks User ID</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.freshchat_user_id }}</td>
          <td class="pb-3 pt-3 px-3"><strong>Customer Name</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.first_name }} {{ customer.last_name }}</td>
        </tr>
        <tr>
          <td class="pb-3 pt-3 px-3"><strong>Main number</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.main_number }}</td>
          <td class="pb-3 pt-3 px-3"><strong>Alternative Number</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.alternative_number }}</td>
        </tr>
        <tr>
          <td class="pb-3 pt-3 px-3"><strong>Email Address</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.email_address ? customer.email_address : '-' }}</td>
          <td class="pb-3 pt-3 px-3"><strong>KRA PIN Number</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.kra_pin_number ? customer.kra_pin_number : '-' }}</td>
        </tr>
        <tr>
          <td class="pb-3 pt-3 px-3"><strong>City</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.city }}, {{ customer.region }}</td>
          <td class="pb-3 pt-3 px-3"><strong>Physical Address</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.physical_address ? customer.physical_address : '-' }}</td>
        </tr>
        <tr>
          <td class="pb-3 pt-3 px-3"><strong>Source</strong></td>
          <td class="pb-3 pt-3 px-3"> {{ customer.source ? customer.source : '-' }}</td>
        </tr>
      </table>
    </div>
    <h2 class="mb-8 text-2xl font-bold mt-5">Orders</h2>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3 text-center">Items Ordered</th>
          <th class="pb-3 pt-3 px-3 flex items-end justify-end">Total Amount</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3" />
        </tr>
        <tr v-for="order in orders.data" :key="order.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" @click="orderDetails(order)">
              {{ order.date }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" @click="orderDetails(order)">
              {{ order.order_no }}
            </a>
          </td>
          <td class="border-t text-center">
            <a class="flex items-center justify-center px-3 py-3 focus:text-orange-500" @click="orderDetails(order)">
              {{ order.items }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-end justify-end px-3 py-3 focus:text-orange-500" @click="orderDetails(order)">
              {{ order.amount }}
            </a>
          </td>
          <td class="border-t">
            <a class="flex items-center px-3 py-3 focus:text-orange-500" @click="orderDetails(order)">
              {{ order.status }}
            </a>
          </td>
          <td class="w-px border-t">
            <a class="flex items-center px-3" href="#" tabindex="-1" @click="orderDetails(order)">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="9">No data found</td>
        </tr>
      </table>
    </div>
  </div>
  <div v-if="openOrder" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-3/4"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>
              Order #{{ orderObj.order_no }} - {{ orderObj.customer }}
              <span v-if="orderObj.status === 'Declined'" class="declined"> [Declined][Reason: {{
      orderObj.decline_reason }}] </span>
              <span v-else class="approved"> [{{ orderObj.status }}] </span>
            </h1>
          </div>
          <div v-if="listDetails.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size:20px; font-weight: bold;">
                    Ordered Details
                  </h1>
                </div>
              </div>
            </div>
            <div class="mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Quantity</th>
                  <th class="pb-3 pt-3 px-3">Unit Price</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3 text-end float-right">Amount</th>
                </tr>
                <tr v-for="(item, index) in listDetails" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.sku }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3"
                    style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal !important; width: 30%;">
                    <span class="flex items-left px-3">{{ item.description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.quantity }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.unit_cost }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">{{ item.discount_rate }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{ item.amount }}</span>
                  </td>
                </tr>
                <tr v-if="orderObj.transport && orderObj.transport > 0">
                  <td class="w-px border-t pb-3 pt-3" width="2%"><span class="flex items-center px-3"> {{
      listDetails.length + 1 }}</span></td>
                  <td class="w-px border-t pb-3 pt-3" width="10%">
                    <span class="flex items-left px-3">{{ orderObj.transport_name }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3" width="30%">
                    <span class="flex items-left px-3">{{ orderObj.transport_description }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center justify-center px-3">1</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3" width="5%">
                    <span class="flex items-center justify-center px-3">{{ orderObj.transport_amount }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3" width="5%">
                    <span class="flex items-center justify-center px-3">0</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.transport_amount }}</span>
                  </td>
                </tr>
                <tr v-if="orderObj.voucherInfo && orderObj.voucherInfo.code && orderObj.has_discount_voucher == 0">
                  <td class="pb-3 pt-3  border-t border-b"><span class="flex items-center px-3">-</span></td>
                  <td class="pb-3 pt-3  border-t border-b" colspan="5"> Voucher Code: #{{ orderObj.voucherInfo.code }} -
                    {{ orderObj.voucherInfo.value }} {{ orderObj.voucherInfo.type === 'Percentage' ? '%' : '' }}</td>
                  <td class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.voucherInfo.voucher_amount
                      }}</span>
                  </td>
                </tr>
                <tr>
                  <th class="pb-3 pt-3  border-t border-b">Total</th>
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.amount }}</span>
                  </th>
                </tr>
              </table>
            </div>
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size:20px; font-weight: bold;">
                    Payment Details
                  </h1>
                </div>
              </div>
            </div>
            <div v-if="orderObj.payments.length" class="mb-4 overflow-x-auto">
              <table class="whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">Date</th>
                  <th class="pb-3 pt-3 px-3">Payment Mode</th>
                  <th class="pb-3 pt-3 px-3">Reference</th>
                  <th class="pb-3 pt-3 px-3">Initiated By</th>
                  <th class="pb-3 pt-3 px-3">Phone Number</th>
                  <th class="flex items-end px-3 items-end justify-end">Amount</th>
                </tr>
                <tr v-for="(item, index) in orderObj.payments" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.date }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.provider }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3 break-all"
                    style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal !important; width: 30%;">
                    <p class="px-3">{{ item.reference }}</p>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.user }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.phone_number }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{ item.amount }}</span>
                  </td>
                </tr>
                <tr>
                  <th class="pb-3 pt-3  border-t border-b">Total</th>
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ orderObj.total_payments }}</span>
                  </th>
                </tr>
              </table>
            </div>
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size:20px; font-weight: bold;">
                    Notes
                  </h1>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <p v-show="orderObj.notes">{{ orderObj.notes }}</p>
            </div>
          </div>
          <div v-else class="p-5">No order details not found.</div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal">
                Close
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button v-if="!(orderObj.status != 'Declined' || orderObj.status != 'Cancelled')" type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1"
                @click="addPayment(orderObj)">
                Add Payment
              </button>
            </span>
            <span v-show="amountToPay > 0" class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button v-if="!(orderObj.status != 'Declined' || orderObj.status != 'Cancelled')" type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1"
                @click="makePaymentModel(orderObj)">
                Initiate Payment
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openEditCustomer" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-1/2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6" style="display:inline !important;">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
              </svg>
              Update Customer
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form enctype="multipart/form-data" @submit.prevent="update">
                <div v-show="filters.freshchat_user_id || formData.freshchat_user_id" class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                  <text-input v-model="formData.freshchat_user_id" :error="$props.errors.freshchat_user_id"
                    class="pb-8 pr-6 w-1/2 lg:w-full" label="Freshworks User ID" />
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                  <text-input v-model="formData.first_name" :error="$props.errors.first_name"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="First Name" />
                  <text-input v-model="formData.last_name" :error="$props.errors.last_name"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Last Name" />
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                  <text-input v-model="formData.main_number" :error="$props.errors.main_number"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Main Phone Number" />
                  <text-input v-model="formData.alternative_number" :error="$props.errors.alternative_number"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Alternative Phone Number" />
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                  <text-input v-model="formData.email_address" :error="$props.errors.email_address"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Email Address" />
                  <text-input v-model="formData.kra_pin_number" :error="$props.errors.kra_pin_number"
                    class="pb-8 pr-6 w-1/2 lg:w-1/2" label="KRA PIN Number" />
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                  <p class="pb-1">Select Source</p>
                  <multiselect id="source" v-model="formData.source" placeholder="Search Sources" :options="sources"
                    :clear-on-select="false" :preserve-search="true" :searchable="true" class="mt-1 w-1/2"
                    :close-on-select="true" :create-option="true" :error="$props.errors.source"
                    :style="$props.errors.source ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.source }}</small></p>
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-4 pl-2 pr-8 pb-8">
                  <p class="pb-1">Select City</p>
                  <multiselect id="city" v-model="formData.city" placeholder="Search Cities" :options="cities"
                    :clear-on-select="false" :preserve-search="true" :searchable="true" class="mt-1"
                    :close-on-select="true" :create-option="true" :error="$props.errors.city"
                    :style="$props.errors.city ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                  <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.city }}</small></p>
                </div>
                <div class="flex flex-wrap -mb-8 -mr-6 pt-4 pl-2 pr-2 pb-10">
                  <text-input v-model="formData.physical_address" :error="$props.errors.physical_address"
                    class="pb-8 pr-6 w-full lg:w-full" label="Physical Address" />
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="update">
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openCreateOrder" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-3/4 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6" style="display: inline !important;">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
              </svg>

              New Order for - {{ customer.first_name }} {{ customer.last_name }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form @submit.prevent="store">
                <div v-if="stepOne">
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                    <select-input v-model="orderData.payment_detail" :error="$props.errors.payment_detail"
                      class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Payment Details">
                      <option :value="null">-Select-</option>
                      <option v-for="payment in payment_details" :key="payment">{{ payment }}</option>
                    </select-input>
                    <select-input v-model="orderData.shipping_type" :error="$props.errors.shipping_type"
                      class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Shipping Type">
                      <option :value="null">-Select-</option>
                      <option v-for="shipping_type in shipping_types" :key="shipping_type">{{ shipping_type }}</option>
                    </select-input>
                    <select-input v-if="orderData.shipping_type === 'Pickup'" v-model="formData.pickup_location"
                      :error="$props.errors.pickup_location" class="pb-8 pr-6 w-full lg:w-full"
                      label="Pick Up Location">
                      <option :value="null">-Select-</option>
                      <option v-for="pickup_location in pickup_locations" :key="pickup_location">{{ pickup_location }}
                      </option>
                    </select-input>
                    <select-input v-model="orderData.point_of_sale" :error="$props.errors.point_of_sale"
                      class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Point Of Sale">
                      <option :value="null">-Select-</option>
                      <option v-for="point_of_sale in points_of_sale" :key="point_of_sale">{{ point_of_sale }}</option>
                    </select-input>
                    <text-input v-model="orderData.delivery_date" type="date" :error="$props.errors.delivery_date"
                      class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Delivery Date" />
                  </div>
                  <div class=" hidden flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                    <p class="pb-1">Select Referral</p>
                    <multiselect id="referral" v-model="orderData.referral" placeholder="Search Referrals"
                      :options="null" :clear-on-select="false" :preserve-search="true" :searchable="true"
                      class="mt-1 w-1/2" :close-on-select="true" :create-option="true" :error="$props.errors.referral"
                      :style="$props.errors.referral ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                    <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.referral }}</small></p>
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                    <text-input v-model="orderData.notes" :error="$props.errors.notes"
                      class="pb-8 pr-6 w-full lg:w-full" label="Notes" />
                  </div>
                  <div class="flex flex-wrap -mb-10 -mr-6 pt-2 pl-2 pr-8 pb-10">
                    <p class="pb-1">Select Responsible Agent</p>
                    <multiselect id="responsible_agent" v-model="orderData.responsible_agent"
                      placeholder="Search Agents" :options="agents" :clear-on-select="false" :preserve-search="true"
                      :searchable="true" class="mt-1 w-1/2" :error="$props.errors.responsible_agent"
                      :style="$props.errors.responsible_agent ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                    <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.responsible_agent
                        }}</small></p>
                  </div>
                  <div v-if="orderData.payment_detail === 'Prepaid'"
                    class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                    <p class="pb-1">Select mode of payment</p>
                    <multiselect id="customer" v-model="orderData.mode_of_pament" placeholder="Search mode of payment"
                      :options="providers" :clear-on-select="false" :preserve-search="true" :searchable="true"
                      class="mt-1 w-1/2" :close-on-select="true" :create-option="true"
                      :error="$props.errors.mode_of_pament"
                      :style="$props.errors.mode_of_pament ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                      @search-change="onSearchCustomerChange" @input="onSelectedCustomer" @select="onSelect" />
                    <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.mode_of_pament }}</small>
                    </p>
                  </div>
                  <div v-if="orderData.payment_detail === 'Prepaid'"
                    class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-10">
                    <text-input v-model="orderData.payment_reference" :error="$props.errors.payment_reference"
                      class="pb-2 pr-6 w-1/2 lg:w-1/2" label="Payment Reference" />
                    <text-input v-model="orderData.payment_amount" :error="$props.errors.payment_amount"
                      class="pb-2 pr-6 w-1/2 lg:w-1/2" label="Payment Amount" />
                  </div>
                  <p class="pb-10" />
                </div>
                <div v-if="stepTwo">
                  <div class="bg-orange-50 rounded-md shadow mb-4">
                    <div class="grid grid-cols-1 gap-4 p-3">
                      <div class="flex flex-wrap" v-for="(item, index) in orderData.details" :key="index">
                        <div class="w-2/4 pr-2">
                          <p class="pb-2">Select SKU</p>
                          <multiselect id="part_number" :key="index" v-model="item.part_number" placeholder="Search SKU"
                            :options="skus" :clear-on-select="false" :preserve-search="true" :searchable="true"
                            class="mt-1 w-1/2" :close-on-select="true" :create-option="true"
                            :error="showValidationErrors(`details.${index}.part_number`)"
                            :style="showValidationErrors(`details.${index}.part_number`) ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                          <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{
      showValidationErrors(`details.${index}.part_number`) }}</small></p>
                        </div>
                        <div class="w-1/4 pr-2">
                          <p class="pb-2">Quantity</p>
                          <text-input :key="index" v-model="item.quantity"
                            :error="showValidationErrors(`details.${index}.quantity`)" placeholder="Quantity"
                            class="pb-2 pr-6 w-full lg:w-full" />
                        </div>
                        <div class="w-1/4 pr-2">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-6 h-6 mt-8 text-green-600"
                            style="display: inline !important; cursor: pointer;" @click="addItem">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <svg v-show="orderData.details.length > 1" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            class="w-6 h-6 text-red-600 mt-8" style="display: inline !important; cursor: pointer;"
                            @click="removeItem(index, orderData.details)">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-10">
                    <select-input v-model="orderData.voucher" :error="$props.errors.voucher"
                      class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Voucher Code">
                      <option :value="null">-Select-</option>
                      <option v-for="voucher in vouchers" :key="voucher.id" :value="voucher.id">{{ voucher.code }}
                      </option>
                    </select-input>
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-10">
                    <text-input v-model="orderData.kilometer"
                      :error="$props.errors.kilometer" label="Extra Kilometers"
                      class="pb-2 pr-6 w-full lg:w-full" />
                  </div>
                </div>
                <div v-if="stepOne">
                  <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button
                      class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                      @click="showNext">
                      Add/View Products
                    </button>
                  </span>
                </div>
                <div v-if="stepTwo">
                  <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button
                      class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-green-600 ml-0 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                      @click="showBack">
                      View Order Header
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="confirmOrderModal">
                Submit
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openCreateVoucher" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white w-1/2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6 pb-1" style="display: inline !important;">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
              </svg>
              Create Voucher
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form @submit.prevent="storeVoucher">
                <div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                    <p class="pb-1">Select Reason:</p>
                    <multiselect id="voucher_reason" v-model="voucherData.voucher_reason" placeholder="Search Reasons"
                      :options="voucherReasons" :clear-on-select="false" :preserve-search="true" :searchable="true"
                      class="mt-1 w-1/2" :create-option="true" :error="$props.errors.voucher_reason"
                      :style="$props.errors.voucher_reason ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                      @select="onSelect" />
                    <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.voucher_reason }}</small>
                    </p>
                  </div>
                  <div class="w-fupp pl-2 pb-2 pt-4 pr-6">
                    <p class="pb-1">Description:</p>
                    <text-input v-model="voucherData.description" :error="$props.errors.description"
                      class="pb-2 w-full lg:w-full" />
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-3 pl-2 pr-2 pb-2">
                    <text-input v-model="voucherData.value" :error="$props.errors.value"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Value" />
                    <select-input v-model="voucherData.category" :error="$props.errors.category"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Category">
                      <option :value="null">-Select-</option>
                      <option value="0">Non Transport</option>
                      <option value="1">Transport</option>
                    </select-input>
                    <select-input v-model="voucherData.type" :error="$props.errors.type"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Voucher Type">
                      <option :value="null">-Select-</option>
                      <option v-for="typ in types" :key="typ">{{ typ }}</option>
                    </select-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="storeVoucher">
                Submit
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isMakePaymentOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex flex-wrap w-full items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Make Payment for order#{{ form.order_on }}</h1>
          </div>
          <div v-if="!merchantRequestId" class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="flex flex-wrap w-full w-full">
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input v-model="form.phone_number" :error="phonenumberError" placeholder="Phone Number"
                    label="Phone Number" />
                </div>
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input v-model="form.amount" :error="amountError" class="pb-2" placeholder="Amount"
                    label="Amount" />
                </div>
              </div>
            </div>
            <div v-if="loading" style="color:green">
              <p> Processing, kindly wait...</p>
            </div>
            <div v-else>
              <p v-if="status == 1 && mpesa_response" style="color:green">
              <div class="flex items-center justify-between mb-6">
                <p>{{ mpesa_response }}</p>
                <span class="mt-3 flex w-1/3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
                  <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                  bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                  focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                  sm:leading-5" @click="checkPayment()">
                    Refresh
                  </button>
                </span>
              </div>
              </p>
              <p v-else-if="status == 0 && mpesa_response" style="color:red">{{ mpesa_response }}</p>
              <p v-else></p>
            </div>
          </div>
          <div v-else class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div v-if="message" class="flex items-center justify-between mb-6">
              <span v-if="complete == 'completed'" style="color:green">
                <p>{{ message }} </p>
              </span>
              <span v-else>
                <p style="color: red">{{ message }} </p>
              </span>
            </div>
            <div v-else class="flex items-center justify-between mb-6">
              <span>
                <p>Click the refresh button.</p>
              </span>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button v-if="!merchantRequestId" type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5" @click="confirmMakePaymentModel()">
                Send
              </button>
              <button v-else type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                sm:leading-5" @click="checkPayment()">
                Refresh
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closePaymentModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isConfirmPaymentOpen">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to initiate payment from <strong>{{ form.customer_name }} {{ form.phone_number
                  }}</strong>. Proceed?
              </p>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5" @click="makePaymentOrder()">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button @click="closeConfirmMakePaymentModel" type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="showAddPayment" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-3/4"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 class="text-3xl font-bold">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6" style="display: inline !important;">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
              </svg>

              Add Payment Details
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <form @submit.prevent="store">
                <div v-if="stepOne">
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-8 pb-8">
                    <p class="pb-1">Select Mode of Payment</p>
                    <multiselect id="provider" v-model="formPaymentData.payment_provider"
                      placeholder="Search Mode of Payment" :options="providers" :clear-on-select="false"
                      :preserve-search="true" :searchable="true" class="mt-1 w-1/2" :close-on-select="true"
                      :create-option="true" :error="$props.errors.payment_provider"
                      :style="$props.errors.payment_provider ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                      @search-change="onSearchPaymentProviderChange" @input="onSelectedProvider" @select="onSelect" />
                    <p v-if="$props.errors" class="text-red-700 pt-2"><small>{{ $props.errors.payment_provider
                        }}</small></p>
                  </div>
                  <div class="flex flex-wrap -mb-8 -mr-6 pt-2 pl-2 pr-2 pb-2">
                    <text-input v-model="formPaymentData.date" type="date" :error="$props.errors.date"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Date" />
                    <text-input v-model="formPaymentData.reference" :error="$props.errors.reference"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Reference" />
                    <text-input v-model="formPaymentData.amount" type="number" :error="$props.errors.amount"
                      class="pb-8 pr-6 w-1/3 lg:w-1/3" label="Amount" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="storePayment">
                Submit
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isConfirmOrderCreation" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to create an order. Proceed?
              </p>
            </div>
            <div v-if="(popUpErrors)" class="flex items-center justify-between mb-8 max-w-3xl bg-red-500 rounded">
              <div class="flex items-center">
                <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path
                    d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" />
                </svg>
                <div v-if="$page.props.flash.error" class="py-4 text-white text-sm font-medium">{{
      $page.props.flash.error }}</div>
                <div v-else class="py-4 text-white text-sm font-medium">
                  <span v-if="Object.keys($page.props.errors).length === 1">There is one form error. Please click the
                    cancel button to fix it.</span>
                  <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors. Please click the
                    cancel button to fix them.</span>
                </div>
              </div>
              <button type="button" class="group mr-2 p-2" @click="show = false">
                <svg class="block w-2 h-2 fill-red-800 group-hover:fill-white" xmlns="http://www.w3.org/2000/svg"
                  width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908">
                  <path
                    d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" />
                </svg>
              </button>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                sm:leading-5" @click="store('save-and-confirm')">
                Save and Confirm
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5" @click="store()">
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button @click="closeConfirmOrderModel" type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    TextInput,
    Multiselect,
    SelectInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    customer: Object,
    orders: Object,
    sources: Object,
    cities: Object,
    errors: Object,
    skus: Object,
    payment_details: Array,
    shipping_types: Array,
    points_of_sale: Array,
    pickup_locations: Array,
    providers: Object,
    agents: Object,
    logged_in_user_id: Number,
    vouchers: Object,
    voucherReasons: Object,
    types: Array,
  },
  data() {
    return {
      orderObj: [],
      openOrder: false,
      listDetails: [],
      openEditCustomer: false,
      openCreateOrder: false,
      stepOne: true,
      stepTwo: false,
      showAddPayment: false,
      openCreateVoucher: false,
      popUpErrors: null,
      formData: {
        'first_name': null,
        'last_name': null,
        'main_number': null,
        'alternative_number': null,
        'email_address': null,
        'kra_pin_number': null,
        'physical_address': null,
        'source': null,
        'city': null,
        'freshchat_user_id': this.filters.freshchat_user_id,
        'freshchat_conversation_id': this.filters.freshchat_conversation_id,
      },
      formPaymentData: {
        'date': null,
        'reference': null,
        'amount': null,
        'payment_provider': null,
      },
      orderData: {
        'payment_detail': null,
        'shipping_type': null,
        'point_of_sale': null,
        'pickup_location': null,
        'delivery_date': null,
        'customer': this.customer.id,
        'notes': null,
        'voucher': null,
        'responsible_agent': this.logged_in_user_id,
        'transport': null,
        'mode_of_pament': null,
        'payment_reference': null,
        'payment_amount': null,
        'partial_delivery': 0,
        'kilometer': null,
        'details': [{
          part_number: null,
          quantity: null,
        }],
      },
      voucherData: {
        'description': null,
        'voucher_reason': null,
        'type': null,
        'value': null,
        'category': null,
        'customer': this.customer.id,
      },
      form: this.$inertia.form({
        order_id: null,
        order_no: null,
        phone_number: null,
        amount: null,
        customer_name: null,
      }),
      showAddPayment: false,
      isMakePaymentOpen: false,
      isConfirmPaymentOpen: false,
      mpesa_response: null,
      status: 0,
      merchantRequestId: null,
      amountError: null,
      phonenumberError: null,
      loading: false,
      complete: null,
      message: null,
      isConfirmOrderCreation: false,
    }
  },
  computed: {
    amountToPay() {
      const totalPaid = this.orderObj.total_payments.replace(/,/g, "")
      const amountToPay = this.orderObj.amount.replace(/,/g, "")
      const total = (amountToPay - totalPaid)
      this.form.amount = total
      return total
    },
  },
  methods: {
    orderDetails(item) {
      this.orderObj = item
      this.openOrder = true
      this.listDetails = item.details
    },
    closeModal() {
      this.openOrder = false
      this.openEditCustomer = false
      this.openCreateOrder = false
      this.openCreateVoucher = false
      this.showAddPayment = false
      this.voucherData.description = null
      this.voucherData.type = null
      this.voucherData.value = null
      this.voucherData.customer = null
    },
    openEditCustomerPrompt() {
      this.openEditCustomer = true
      this.formData.first_name = this.customer.first_name
      this.formData.last_name = this.customer.last_name
      this.formData.main_number = this.customer.main_number
      this.formData.alternative_number = this.customer.alternative_number
      this.formData.email_address = this.customer.email_address
      this.formData.kra_pin_number = this.customer.kra_pin_number
      this.formData.physical_address = this.customer.physical_address
      this.formData.source = this.customer.source
      this.formData.city = this.customer.city_id
      this.formData.freshchat_user_id = this.customer.freshchat_user_id
    },
    confirmOrderModal() {
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = false
      this.isMakePaymentOpen = false
      this.openCreateOrder = true
      this.isConfirmOrderCreation = true
    },
    closeConfirmOrderModel() {
      this.popUpErrors = null
      this.openCreateOrder = true
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = false
      this.isMakePaymentOpen = false
      this.isConfirmOrderCreation = false
      this.isOrderConfirmOpen = false
    },
    makePaymentModel(order) {
      this.form.order_id = order.id
      this.form.customer_name = order.customer
      this.form.order_on = order.order_no
      this.openCreateOrder = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = false
      this.isMakePaymentOpen = true
    },
    confirmMakePaymentModel() {
      this.openCreateOrder = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = true
      this.isMakePaymentOpen = true
      this.mpesa_response = null
      this.loading = false
      this.status = 0
    },
    closePaymentModal() {
      this.openCreateOrder = false
      this.showAddPayment = false
      this.isMakePaymentOpen = false
      this.mpesa_response = null
      this.form.phone_number = null
      this.isConfirmPaymentOpen = false
      this.merchantRequestId = null
      this.message = null
      this.complete = null
    },
    checkPayment() {
      const data = {}
      data.merchant_request_id = this.merchantRequestId
      const self = this
      axios.post('/payments/check-payment', data).then(response => {
        if (response) {
          self.message = response.data.message
          self.complete = response.data.status
          self.isMakePaymentOpen = true
          self.status = null
          self.mpesa_response = null
        }
      }).catch(function (error) {

      })
    },
    makePaymentOrder() {
      const data = {}
      data.order_id = this.form.order_id
      data.phone_number = this.form.phone_number
      data.amount = this.form.amount
      data._method = 'POST'
      const self = this
      self.loading = true;
      this.isConfirmPaymentOpen = false
      axios.post('/payments/process', data).then(response => {
        if (response) {
          self.show = true
          self.mpesa_response = response.data.message
          self.status = response.data.status
          self.stepOne = true
          self.stepTwo = false
          self.openCreateOrder = false
          self.isMakePaymentOpen = true
          self.isConfirmPaymentOpen = false
          self.merchantRequestId = response.data.merchant_request_id
        }
      }).catch(function (error) {
        if (error.response.status === 422) {
          const { amount, phone_number } = error.response.data.errors
          if (phone_number) {
            const [n] = phone_number;
            self.phonenumberError = n
          }
          if (amount) {
            const [a] = amount;
            self.amountError = a
          }
        }
        self.isConfirmPaymentOpen = false
        self.isMakePaymentOpen = true
      }).then(() => {
        self.loading = false;
      })
    },
    addItem(e) {
      e.preventDefault()
      this.orderData.details.push({
        part_number: null,
        quantity: null,
      })
    },
    removeItem(index, details) {
      details.splice(index, 1)
    },
    openCreateCustomerOrderPrompt() {
      this.openCreateOrder = true
    },
    openCreateCustomerVoucherPrompt() {
      this.openCreateVoucher = true
      this.voucherData.description = null
      this.voucherData.voucher_reason = null
      this.voucherData.type = null
      this.voucherData.category = null
      this.voucherData.value = null
      this.voucherData.customer = null
    },
    showNext() {
      this.stepOne = false
      this.stepTwo = true
    },
    showBack() {
      this.stepOne = true
      this.stepTwo = false
    },
    storeVoucher() {
      this.voucherData._method = 'post'
      this.$inertia.post(`/online-customers/${this.customer.id}/create-voucher`, this.voucherData, {
        onSuccess: () => {
          this.voucherData.description = null
          this.voucherData.voucher_reason = null
          this.voucherData.type = null
          this.voucherData.category = null
          this.voucherData.value = null
          this.voucherData.customer = null
          this.openCreateVoucher = false
        },
      })
    },
    update() {
      this.formData._method = 'put'
      this.$inertia.post(`/online-customers/${this.customer.id}`, this.formData, {
        onSuccess: () => {
          this.openEditCustomer = false
          this.orderData.payment_detail = null
          this.orderData.shipping_type = null
          this.orderData.point_of_sale = null
          this.orderData.pickup_location = null
          this.orderData.delivery_date = null
          this.orderData.customer = null
          this.orderData.referral = null
          this.orderData.notes = null
          this.orderData.voucher = null
          this.orderData.transport = null
          this.orderData.mode_of_pament = null
          this.orderData.payment_reference = null
          this.orderData.payment_amount = null
          this.orderData.partial_delivery = 0
          this.orderData.responsible_agent = null
          this.orderData.details = [{
            part_number: null,
            quantity: null,
          }]
        },
      })
    },
    showValidationErrors(value) {
      if (this.$props.errors) {
        const error = this.$props.errors[value] || ''
        return error || ''
      }
      return ''
    },
    store(value) {
      this.orderData.action = 'save'
      if (value == 'save-and-confirm') {
        this.orderData.action = value
      }
      this.$inertia.post('/online-customer-order', this.orderData, {
        onSuccess: () => {
          this.openCreateOrder = false
          this.isConfirmOrderCreation = false
        },
        onError: (error) => {
          this.popUpErrors = error
        },
      })
    },
    addPayment(item) {
      this.showAddPayment = true
    },
    storePayment() {
      this.formPaymentData.order_id = this.orderObj.id
      this.formPaymentData._method = 'post'
      this.$inertia.post('/order-payments', this.formPaymentData, {
        onSuccess: () => {
          this.formPaymentData.date = null
          this.formPaymentData.amount = null
          this.formPaymentData.payment_provider = null
          this.formPaymentData.reference = null
          this.showAddPayment = false
          this.isMakePaymentOpen = false
          this.isConfirmPaymentOpen = false
        },
      })
    },
    url(customer) {
      let url = `/online-orders/create?i=${customer.id}&n=${customer.first_name} ${customer.last_name}`;
      if (this.filters.freshchat_user_id && this.filters.freshchat_conversation_id) {
        url = `/online-orders/create?i=${customer.id}&n=${customer.first_name} ${customer.last_name}&freshchat_user_id=${this.filters.freshchat_user_id}&freshchat_conversation_id=${this.filters.freshchat_conversation_id}`;
      }
      return url
    },
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}

.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}

.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}

.approved {
  color: green;
}

.declined {
  color: red;
}
</style>